import sdl from '@jds/react-generated-sdl/JDSNudge';
import type { JDSNudgeProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, NudgeProps } from '../logic';

const Component = (props: NudgeProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    open = false,
    showClose = true,
    closeButtonAriaLabel = 'Close Nudge',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { open, showClose, closeButtonAriaLabel, ...rest },
    'JDSNudge',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Nudge = withLogic(Component) as React.FC<NudgeProps> & {
  slotName?: string;
};

Nudge.displayName = 'Nudge';
Nudge.slotName = 'jds_nudge';

export { Nudge, type JDSNudgeProps };
